import { Command, AlphabeticalData } from '../interfaces';

export enum ALPHABETICAL_SORT {
    A_Z = 'A_Z',
    Z_A = 'Z_A',
}

/**
 * Sort based on the title. I.e a-z or z-a.
 * @param data a treatment
 * @returns AlphabeticalData[]
 */
export const alphabeticalSort = <T extends AlphabeticalData>(data: T[], keys: keyof typeof ALPHABETICAL_SORT) => {
    let result: AlphabeticalData[] = [];
    if (keys === ALPHABETICAL_SORT.A_Z) {
        result = data.sort((a, b) => a.title.localeCompare(b.title, undefined, { sensitivity: 'base' }));
    }
    if (keys === ALPHABETICAL_SORT.Z_A) {
        result = data.sort((a, b) => b.title.localeCompare(a.title, undefined, { sensitivity: 'base' }));
    }
    return result;
};

export class AlphabeticalSortCommand implements Command {
    isAndFilter() {
        return undefined;
    }

    execute(data: AlphabeticalData[], keys: keyof typeof ALPHABETICAL_SORT) {
        return alphabeticalSort(data, ALPHABETICAL_SORT[keys]);
    }
}
